import services from './../../services/service'; // Service Class
let service = new services();

export default {
    name: 'DashboardSidebar',
    data () {
        return {
            user: {},
            notifications_contracts: 0,
            notifications_cnpros: 0,
            notifications_cnsurveys: 0,
            show: true
        }
    },
    methods: {
        isActive(page){
            if(page == localStorage.getItem("cn_current_page")){
                return true;
            }
        },
        preset() {
            var credentials = {
                session_key: localStorage.getItem("cityneeds_token")
            } 
           if(credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(response => {
                    if(response.body.status == 200) {
                        let data = response.body.data;
                        data.forEach(function(element) {
                            this.user.user_id = element.user_id;
                            //
                            this.getNotifications();
                        }, this);
                        }else {
                            this.$router.push('login');
                      }
                }).catch((err) => {
                    if(err) {
                     this.$router.push('login');
                    }
                })
            }else {
                this.$router.push('login');
            }
            
        },
        getNotifications() {
            //prepare id
            var credentials = {
                session_key: localStorage.getItem("cityneeds_token")
            } 
           if(credentials.session_key != null) {
             service.sessionGuard(this, credentials).then(response => {
                    if(response.body.status == 200) {
                       let data = response.body.data;
                        data.forEach(function(element) {
                            this.user.user_id = element.user_id;

                            //get the notification
                            service.getNotifications(this, this.user.user_id).then(data => {
                                if(data.body.status == 200) {
                                    this.notifications_contracts = data.body.notifications_contracts;
                                    this.notifications_cnpros = data.body.notifications_cnpros;
                                    this.notifications_cnsurveys = data.body.notifications_cnsurveys;
                                }
                            }).catch((err) => {
                                if(err) {
                                     toastr.error('Sorry, could not process information!', 'Warning!');
                                }
                            })

                            //get the notification


                        }, this);
                        }
                }).catch((err) => {
                    if(err) {
                    
                    }
                })
            }

           
           
        },
    },
    created: function () {
        this.getNotifications();
        localStorage.setItem("cn_current_page", this.$route.path);
    }
}


// WEBPACK FOOTER //
// ./src/components/Dashboard-Sidebar/script.js